import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


const ImpersonateLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      try {
        // Token ko localStorage me save kar do (jaise normal login me karte ho)
        localStorage.setItem("authToken", token);

        // Optional: user info decode karke console me dekh lo
       const decoded = jwtDecode(token);
        console.log("Impersonated user:", decoded);

        // Ab client ke dashboard (ya Home) par redirect
        navigate("/studio/galleries");
      } catch (err) {
        console.error("Invalid token:", err);
        navigate("/login");
      }
    } else {
      // Agar token missing hai to normal login par bhej do
      navigate("/login");
    }
  }, [navigate]);

  return <h2>Logging in as client...</h2>;
};

export default ImpersonateLogin;
